export enum ChangeOrderCSTab {
  header = "header",
  itemDetails = "itemDetails"
}

export enum typeConfirmDelete {
  cancelOrder = "cancelOrder",
  cancelOrderLine = "cancelOrderLine"
}

export type SubmitStatus =
  | "idle"
  | "confirmPopup"
  | "splitConfirmPopup"
  | "errorPopup"
  | "errorNotify"
  | "processing"
  | "validationError"
  | "undoCancelPopup"
  | "noPriceInSapPopup"
  | "noPriceCalculationPopup"
  | "confirmBackPopup"
  | "submitted"
  | "timeout";
